import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import './design/tokens.css'
import './design/base.css'
import './design/shell.css'

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

// The service worker is what makes the field app installable and usable offline.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    // Registration fails in sandboxed webviews and on insecure origins. The outbox keeps
    // working either way, so this is logged and ignored rather than surfaced.
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.info('Offline shell unavailable in this browser:', err?.message ?? err)
    })
  })
}
